import { Flex, Icon, IconButton, Text } from '@/ui';

type Props = {
  value: number;
  min: number;
  max: number;
  /** How far one press moves the value. Defaults to 1. */
  step?: number;
  isDisabled?: boolean;
  decreaseLabel: string;
  increaseLabel: string;
  onChange: (value: number) => void;
};

// A clamped numeric stepper for seat controls. Callers decide what the number
// means: an existing org steps its *total* seats (so the control answers "how
// many seats do I want?"), while a new one steps the *packs* being added on top
// of the included seats.
export const SeatStepper = ({
  value,
  min,
  max,
  step = 1,
  isDisabled = false,
  decreaseLabel,
  increaseLabel,
  onChange,
}: Props) => (
  <Flex
    align="center"
    borderColor="gray.200"
    borderRadius="ah-lg"
    borderWidth="1px"
    flexShrink={0}
    overflow="hidden"
  >
    <IconButton
      aria-label={decreaseLabel}
      borderRadius="0"
      colorScheme="dark"
      icon={<Icon icon="Minus" size="4" />}
      isDisabled={isDisabled || value <= min}
      variant="ghost"
      onClick={() => onChange(Math.max(min, value - step))}
    />
    <Text
      bg="gray.100"
      borderColor="gray.200"
      borderLeftWidth="1px"
      borderRightWidth="1px"
      fontWeight="medium"
      minW="12"
      py="2"
      textAlign="center"
    >
      {value}
    </Text>
    <IconButton
      aria-label={increaseLabel}
      borderRadius="0"
      colorScheme="dark"
      icon={<Icon icon="Plus" size="4" />}
      isDisabled={isDisabled || value >= max}
      variant="ghost"
      onClick={() => onChange(Math.min(max, value + step))}
    />
  </Flex>
);
